export default {
  login: "ورود",
  email: "ایمیل",
  emailError: "ایمیل اشتباه است",
  password: "رمز عبور",
  passwordError: "رمز عبور اشتباه است",
  brandName: "tenzu shop",
};
